import { render, staticRenderFns } from "./Itemcategory.vue?vue&type=template&id=03aeac2d&"
import script from "./Itemcategory.vue?vue&type=script&lang=js&"
export * from "./Itemcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports